namespace RioERP.Reports {
    export interface FranchiseeSalesReportForm {
        InvoiceDate: Serenity.DateEditor;
        OrderDate: Serenity.DateEditor;
        Invoicenumber: Serenity.StringEditor;
        EPaymentType: Serenity.IntegerEditor;
        CustomerName: Serenity.StringEditor;
        EInvoiceTo: Serenity.IntegerEditor;
        FranchiseeName: Serenity.StringEditor;
        FranchiseeGstin: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductId: Serenity.LookupEditor;
        OrderNumber: Serenity.StringEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        OrderDiscount: Serenity.DecimalEditor;
        ProductDiscount: Serenity.DecimalEditor;
        TaxCategoryName: Serenity.StringEditor;
        InvoiceCompanyId: Serenity.IntegerEditor;
        Total: Serenity.DecimalEditor;
        DiscountAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        CgstRate: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstRate: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstRate: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        TotalTax: Serenity.DecimalEditor;
        EPaymentStatus: Serenity.IntegerEditor;
        InvoiceId: Serenity.IntegerEditor;
        FranchiseeId: Serenity.LookupEditor;
        CustomerId: Serenity.IntegerEditor;
    }

    export class FranchiseeSalesReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.FranchiseeSalesReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeSalesReportForm.init)  {
                FranchiseeSalesReportForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(FranchiseeSalesReportForm, [
                    'InvoiceDate', w0,
                    'OrderDate', w0,
                    'Invoicenumber', w1,
                    'EPaymentType', w2,
                    'CustomerName', w1,
                    'EInvoiceTo', w2,
                    'FranchiseeName', w1,
                    'FranchiseeGstin', w1,
                    'City', w1,
                    'StateName', w1,
                    'ProductName', w1,
                    'ProductId', w3,
                    'OrderNumber', w1,
                    'FranchiseeDiscountAmount', w4,
                    'OrderDiscount', w4,
                    'ProductDiscount', w4,
                    'TaxCategoryName', w1,
                    'InvoiceCompanyId', w2,
                    'Total', w4,
                    'DiscountAmount', w4,
                    'NetAmount', w4,
                    'TaxableAmount', w4,
                    'CgstRate', w4,
                    'CgstAmount', w4,
                    'SgstRate', w4,
                    'SgstAmount', w4,
                    'IgstRate', w4,
                    'IgstAmount', w4,
                    'TotalTax', w4,
                    'EPaymentStatus', w2,
                    'InvoiceId', w2,
                    'FranchiseeId', w3,
                    'CustomerId', w2
                ]);
            }
        }
    }
}
